import React, { Fragment, useContext } from 'react'
import { Card, CardContent, Typography, Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'
import Filters from '../../../../containers/dailyMonitoring/details/filters/Index'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    root: {
      marginTop: theme.spacing(0)
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '14px',
      color: '#4B4B4B'
    },
    highlight: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '14px',
      color: '#4B4B4B'
    },
    data: {
      display: 'flex',
      flexDirection: 'column'
    }
  })
)

type Props = {
  year?: number
  month?: number
  finalDate?: moment.Moment
}

function getBusinessDays ({ year, month, finalDate }: Props) {
  let weekendDays = 0
  for (let index = 1; index < (finalDate?.date() || moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()); index++) {
    if (moment().date(index).get('day') === 6 || moment().date(index).get('day') === 0) {
      weekendDays++
    }
  }

  return finalDate ? finalDate.date() - weekendDays : moment(`${year}-${month}`, 'YYYY-MM').daysInMonth() - weekendDays
}

export default function Dateinfo (): JSX.Element {
  const classes = useStyles()
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const isActualDate = moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').isSame(moment(), 'M')

  return (
    <Fragment>
      <div className={classes.container}>
        <Grid item xs={8}>
          <Card className={classes.root}>
            <CardContent>
              <Grid item container spacing={1}>
                <Grid item xs={12} sm={6} md={3} className={classes.data}>
                  <Grid item xs={12}>Amostra</Grid>
                  <Grid item xs={12} className={classes.highlight}>
                    <Typography className={classes.title}>
                      {`${moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').clone().startOf('month').format('DD/MM/YYYY')} à ${moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').clone().endOf('month').format('DD/MM/YYYY')}`}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.data}>
                  <Grid item xs={12}>Data atual</Grid>
                  <Grid item xs={12} className={classes.highlight}>{moment().format('DD/MMM/YYYY')}</Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.data}>
                  <Grid item xs={12}>Dias corridos</Grid>
                  <Grid item xs={12} className={classes.highlight}>{moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').daysInMonth()}</Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.data}>
                  <Grid item xs={12}>Dias úteis</Grid>
                  <Grid item xs={12} className={classes.highlight}>
                    {isActualDate
                      ? `${getBusinessDays({ ...filters.date })} (até hoje ${getBusinessDays({ finalDate: moment().clone() })})`
                      : `${getBusinessDays({ ...filters.date })}`
                    }
                </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4} style={{ paddingLeft: 10 }}>
          <Filters/>
        </Grid>
      </div>
    </Fragment>
  )
}
